module.exports = __webpack_public_path__ + "img/forgetInput.60766149.svg";